module.exports = __webpack_public_path__ + "img/ya-estas-dentro-del-juego.92f92b8f.png";